import React from 'react';

import * as S from './styles';

const Highlight: React.FC = () => {
  return (
    <S.Container>
      <S.Content className="left">
        <S.HighlightImage />
      </S.Content>
      <S.Content className="right">
        <S.Eye>
          <S.Title>
            raio-x<br />
            de um
            <br />
            desfile
          </S.Title>
          <S.Subtitle>Williwear | inverno 1983</S.Subtitle>
          <S.Author>Por Luigi Torre</S.Author>
          <S.Legend>Willi Smith | Foto: Getty Images</S.Legend>
        </S.Eye>
      </S.Content>
    </S.Container>
  );
};

export default Highlight;
